<template>
  <vxe-colgroup
    :title="title"
    :fixed="fixed"
    :sortable="sortable || columnOption.sortable"
  >
    <template v-slot:header="{ column }">
      <span v-if="isRequired(column.property)" style="color: red">*</span
      ><span>{{ column.title }}</span>
    </template>
    <template v-if="!columnOption.children"  v-slot="scope" >
      <slot v-bind="scope"  :name="columnOption.prop" >
        {{columnText(scope.$index,scope.row,columnOption,scope)}}
      </slot>
    </template>
    <template v-for="(item, index) in columnOption.children">
      <vxe-column
        :key="`${item.prop}${index}`"
        v-bind="item"
        :title="$t(item.label)"
        :field="item.prop"
        :show-overflow="showOverflowTooltip || (item.isNotAutoWrap == true ? true : false)"
        :fixed="item.fixed === true ? 'left' : item.fixed"
        :sortable="sortable || item.sortable"
        :min-width="item.minWidth"
        :tree-node="item.isTree && index == 0 && 0 == item.colIndex"
        v-if="!item.children"
      >
        <template v-slot:header="{ column }">
          <span v-if="isRequired(column.property)" style="color: red">*</span
          ><span>{{ column.title }}</span>
        </template>
        <template v-slot="slotProps">
          <slot v-bind="slotProps" :name="item.prop">{{
            columnText(slotProps.$index, slotProps.row, item, slotProps)
          }}</slot>
        </template>
      </vxe-column>
      <x-dynamic-column
        v-else
        :columnOption="item"
        :columnText="columnText"
        :showOverflowTooltip="showOverflowTooltip"
        :isRequired="isRequired"
        :title="$t(item.label)"
        :key="index"
        :fixed="item.fixed"
        :sortable="sortable"
        :allProps="item.props"
        :colIndex="index"
      >
        <template v-for="myProp in item.props || []" v-slot:[myProp]="scope">
          <slot v-bind="scope" :name="myProp"></slot>
        </template>
      </x-dynamic-column>
    </template>
  </vxe-colgroup>
</template>

<script>
export default {
  name: "x-dynamic-column",
  props: {
    showOverflowTooltip: {
      default: false
    },
    columnOption: {
      type: Object,
      required: !0,
    },
    columnText: Function,
    isRequired: Function,
    fixed: String,
    sortable: Boolean,
    allProps: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: String,
    colIndex: Number,
  },
  mounted() {},
  methods: {},
};
</script>
